<script setup lang="ts">
import type {User} from "~/repository/types";
import {cn} from "~/lib/utils";
import type {HTMLAttributes} from "vue";
import {followButtonVariants, type FollowButtonVariants} from "~/components/ui/user/index";

const props = defineProps<{
  profile: User,
  variant?: FollowButtonVariants['variant'],
  class?: HTMLAttributes['class']
}>()
const {t} = useI18n()

const profile = ref(props.profile)
const {follow, unfollow} = useUserAPI(profile)


</script>

<template>
  <template v-if="!profile.is_owner">
    <Button v-if="!profile.is_followed"
            :variant="variant"
            @click="follow"
            :class="cn(followButtonVariants({ variant}), props.class)">
      {{ t('buttons.follow') }}
    </Button>

    <Button v-else variant="outline" class="bg-transparent" @click="unfollow"
            :class="cn(followButtonVariants({ variant}), props.class)">
      {{ t('buttons.followed') }}
    </Button>
  </template>
</template>